
import Vue from 'vue'
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions('app', [ 'setAppPageTitle' ]),
    setPageTitle(title) {
      if (title && title !== "") {
        document.title = `${Vue.config.appName} - ${title}`
      }
      this.setAppPageTitle(title)
    },
  },

  watch: {
    pageTitle: {
      immediate: true,
      handler: 'setPageTitle',
    },
  },

  beforeDestroy() {
    this.setPageTitle()
  },
}


// WEBPACK FOOTER //
// ./src/mixins/setsPageTitle.js